import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  decrementCartItem,
  incrementCartItem,
  removeFromCart,
} from "../../Redux_Store/actions";

const CartItems = () => {
  const selectCartItems = useSelector((state) => {
    // console.log(state);
    return state.CartReducer.item;
  });
  const dispatch = useDispatch();

  const totalPrice = selectCartItems.reduce(
    (total, item) => total + item.price * item.quantity,
    0
  );
  useEffect(() => {
    // console.log(selectCartItems);
  }, [totalPrice]);
  return (
    <div className="CartItem_Container">
      <div className="mb-6 sm:mb-10 lg:mb-16">
        <h2 className="text-gray-800 text-2xl lg:text-3xl font-bold text-center mb-4 md:mb-6">
          Your Cart
        </h2>
      </div>

      {selectCartItems.map((item) => {
        return (
          <div
            key={item.id}
            className="bg-white w-full border-solid border-2 border-black m-2 rounde"
            // style={{ width: 800 }}
          >
            <div className="max-w-screen-lg px-4 md:px-8 mx-auto">
              <div className="py-5 sm:py-8">
                <div className="flex flex-wrap gap-4 lg:gap-6 sm:py-2.5">
                  <div className="sm:-my-2.5">
                    <div className="group w-24 sm:w-40 h-40 sm:h-56 block bg-gray-100 rounded-lg overflow-hidden relative">
                      <img
                        src={item.img}
                        loading="lazy"
                        alt="pic"
                        className="w-full h-full object-cover object-center group-hover:scale-110 transition duration-200"
                      />
                    </div>
                  </div>

                  <div className="flex flex-col justify-between flex-1">
                    <div>
                      <div className="inline-block text-gray-800 hover:text-gray-500 text-lg lg:text-xl font-bold transition duration-100 mb-1">
                        {item.name}
                      </div>

                      <span className="block text-gray-500">
                        Size: {item.size}
                      </span>
                      <span className="block text-gray-500">Color: White</span>
                    </div>

                    <div>
                      <span className="block text-gray-800 md:text-lg font-bold mb-1">
                        {item.price}
                      </span>

                      <span className="flex items-center text-gray-500 text-sm gap-1">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="w-5 h-5 text-green-500"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M5 13l4 4L19 7"
                          />
                        </svg>
                        In stock
                      </span>
                    </div>
                  </div>

                  <div className="w-full sm:w-auto flex justify-between border-t sm:border-none pt-4 sm:pt-0">
                    <div className="flex flex-col items-start gap-2">
                      <div className="w-20 h-12 flex border rounded overflow-hidden">
                        <input
                          type="number"
                          value={item.quantity}
                          className="w-full focus:ring ring-inset ring-cyan-300 outline-none transition duration-100 px-2 py-6"
                        />

                        <div className="flex flex-col border-l divide-y">
                          <button
                            onClick={() => dispatch(incrementCartItem(item.id))}
                            className="w-6 flex justify-center items-center flex-1 bg-white hover:bg-gray-100 active:bg-gray-200 leading-none select-none transition duration-100"
                          >
                            +
                          </button>
                          <button
                            onClick={() => dispatch(decrementCartItem(item.id))}
                            className="w-6 flex justify-center items-center flex-1 bg-white hover:bg-gray-100 active:bg-gray-200 leading-none select-none transition duration-100"
                          >
                            -
                          </button>
                        </div>
                      </div>

                      <button
                        onClick={() => dispatch(removeFromCart(item.id))}
                        className="text-cyan-500 hover:text-cyan-600 active:text-cyan-700 text-sm font-semibold select-none transition duration-100"
                      >
                        Delete
                      </button>
                    </div>

                    <div className="pt-3 sm:pt-2 ml-4 md:ml-8 lg:ml-16">
                      <span className="block text-gray-800 md:text-lg font-bold">
                        ${(item.price * item.quantity).toPrecision(5)}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })}
      {/* checkout */}
      <div className="flex flex-col items-end gap-6 w-80">
        <div className="w-full sm:max-w-xs bg-gray-100 rounded-lg p-4">
          <div className="space-y-1">
            <div className="flex justify-between text-gray-500 gap-4">
              <span>Subtotal</span>
              <span>${totalPrice}</span>
            </div>

            <div className="flex justify-between text-gray-500 gap-4">
              <span>Shipping</span>
              <span>$4.99</span>
            </div>
          </div>

          <div className="border-t pt-4 mt-4">
            <div className="flex justify-between items-start text-gray-800 gap-4">
              <span className="text-lg font-bold">Total</span>

              <span className="flex flex-col items-end">
                <span className="text-lg font-bold">
                  ${totalPrice + 4.99} USD
                </span>
                <span className="text-gray-500 text-sm">including VAT</span>
              </span>
            </div>
          </div>
        </div>
        <Link to="/payment">
          <button className="w-80 inline-block bg-cyan-500 hover:bg-cyan-600 active:bg-cyan-700 focus-visible:ring ring-cyan-300 text-white text-sm md:text-base font-semibold text-center rounded-lg outline-none transition duration-100 px-6 py-1">
            Check out
          </button>
        </Link>
      </div>
    </div>
  );
};

export default CartItems;
